module.exports = __webpack_public_path__ + "img/card_read.88da03fb.png";